/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { headerBreak } from '@/components/content/Header/styles/break';
import { resBreak } from '@/utils/resBreak';
import { SxProps } from '@mui/material';

export const headerSearchSX = ({ isMobile }: { isMobile?: boolean }): SxProps => ({
	width: isMobile ? 'inherit' : '60ch',
	display: isMobile
		? headerBreak({ mobile: 'flex', desktop: 'none' })
		: headerBreak({ mobile: 'none', desktop: 'inherit' }),
	...(isMobile ? { m:2} : {}),
	position: isMobile ? 'none' : 'relative',right:'20%',
	'& :hover':{borderWidth:1},
	fieldset: isMobile ?{
		border:'none'
	}:{border:'none',borderBottomColor:'#acacac'},
	'& .MuiInputBase-root ' : {
		border: '1px solid'
	},
	'& .MuiInputBase-input':{
		fontSize: headerBreak({mobile:'16px', desktop:'inherit'}) 
	},
	'& .MuiInputBase-input::placeholder': {
	color: '#545454',
	opacity: 1
	},
	mt:0
});


export const HelloRetailHeaderSearchSX = ({ isMobile, showOverLay }: { isMobile?: boolean, showOverLay?:boolean }): SxProps => ({
	width: resBreak<'width'>({mobile:'100%', tablet:'45vw', desktop:'60ch'}),
	p:resBreak<'padding'>({mobile:2, desktop:0, tablet:0}),
	pt:resBreak<'padding'>({mobile:0, desktop:0, tablet:0}),
	'& :hover':{borderWidth:1},
	fieldset: isMobile ?{
		border:'none'
	}:{border:'none',borderBottomColor:'#acacac'},
	'& .MuiInputBase-root ' : {
		border: '1px solid'
	},
	'& .MuiInputBase-input':{
		fontSize: headerBreak({mobile:'16px', desktop:'inherit'})
	},
	mt:0,
	'& input':{
		borderRadius:1,
		scrollMarginTop:'15px'
	},
	zIndex:showOverLay ? 1401: 'inherit',
	  '& .MuiInputBase-input::placeholder': {
        color: 'black',
        opacity: 1
      }
});